import React, {
  useState,
  createContext,
  Dispatch,
  SetStateAction
} from "react";
import { ArticleItem, CategoryItem } from "../global/types";

interface ArticlesContextOptions {
  articles: ArticleItem[];
  setArticles: Dispatch<SetStateAction<ArticleItem[]>>;
  filteredArticlesById: (articleId: string) => ArticleItem[];
  filteredArticlesByCategory: (category?: CategoryItem) => ArticleItem[];
  checkIsArticleInCategory: (articleId:string, categories: CategoryItem[]) => Boolean;
}

export const ArticlesContext = createContext<ArticlesContextOptions>({
  articles: [],
  setArticles: () => [],
  filteredArticlesById: () => [],
  filteredArticlesByCategory: () => [],
  checkIsArticleInCategory: () => false,
});

export const ArticlesProvider: React.FC = ({ children }) => {
  const [articles, setArticles] = useState<ArticleItem[]>([]);

  const filteredArticlesById = (articleId: string): ArticleItem[] => {
    return articles.filter(article => `${article.id}` === articleId);
  };

  const checkIsArticleInCategory = (articleId: string, categories: CategoryItem[]) => {
    const categoryIds = categories.map(category => {
      return category.id
    });

    const article = filteredArticlesById(articleId)[0];

    if (article && categoryIds.indexOf(article.category.id) !== -1) {
      return true;
    }
    
    return false;
  }

  const filteredArticlesByCategory = (
    category?: CategoryItem
  ): ArticleItem[] => {
    return articles.filter(article => category && article.category.id === category.id);
  };

  return (
    <ArticlesContext.Provider
      value={{
        articles,
        setArticles,
        filteredArticlesById,
        filteredArticlesByCategory,
        checkIsArticleInCategory,
      }}
    >
      {children}
    </ArticlesContext.Provider>
  );
};
